function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatSubmiti = function SvgChatSubmiti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M13.518 14.301h.058l.017.01h.037l.014.01c.045 0 .089.02.133.04l21 9a.695.695 0 0 1 0 1.28l-21 9a.68.68 0 0 1-.723-.1.7.7 0 0 1-.236-.69l1.354-6.1a.7.7 0 0 1 .835-.53c.378.09.616.46.532.84l-1.058 4.76 18.243-7.82-18.243-7.82 1.582 7.12h6.32a.7.7 0 1 1 0 1.4h-6.882a.7.7 0 0 1-.683-.55l-2-9a.6.6 0 0 1-.017-.14v-.03l.001-.02.001-.02.002-.02.002-.01.003-.02.003-.02.003-.01a1 1 0 0 1 .042-.14.74.74 0 0 1 .196-.26.63.63 0 0 1 .295-.14c.046-.01.092-.02.138-.02h.031"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatSubmiti);
export default ForwardRef;